import { createRouter, createWebHistory } from 'vue-router';

/**
 * Vue defined routes
 */
let routes = [];

/**
 * Dynamically load custom route files so this file does not grow big.
 * All nested route files will be loaded except `router/index.js`
 */
let files = require.context('./', true, /\.js$/i);

files.keys().map(key => {
    let filename = key.split('/').pop().split('.')[0];
    let path = key.split('/');
    path.shift();
    path.pop();

    if (filename === 'index' && !path.length) return;

    let filepath = './';
    filepath += path.length ? path.join('/') + '/' : '';
    let fileRoutes = require(filepath + filename + '.js');
    routes = routes.concat(fileRoutes.default);
});

/**
 * Initialize the router.
 */
const router = createRouter({
    routes: routes.map(route => {
        if (route.meta.parent) {
            return {
                ...route,
                components: {
                    default: routes.find(r => r.name === route.meta.parent)?.component,
                    slideover: route.component,
                },
            };
        } else {
            return route;
        }
    }),
    history: createWebHistory(),
});

router.afterEach(to => {
    const theme = to.meta?.theme ?? 'default';

    const { classList } = document.body;

    classList.remove(...Array.from(classList.values()).filter(c => c.endsWith('-theme')));
    classList.add(`${theme}-theme`);
});

export default router;
